// extracted by mini-css-extract-plugin
export default {"orb":"Orb_orb__oJRzY","red":"Orb_red__UklE-","yellow":"Orb_yellow__oFwBo","blue":"Orb_blue__pnlZU"};